export default function BannerBigImage({ img, name, view = 0 }) {
  return (
    <div className="col-span-4 row-span-3 relative sm:col-span-3">
      <img src={img} alt='' className="block h-full" />
      <div className="absolute bottom-0 left-0 right-0 pt-8 pb-2 bg-gradient-to-t px-4 opacity-40 from-black to-transparent">
        <div className="text-white">
          <div className="text-sm">{view} lượt xem</div>
          <div className="text-lg font-normal">{name}</div>
        </div>
      </div>
    </div>
  )
}
